const QUOTE_REDIRECT = /^\/quotes\/[^/?#\s\\]+(\?[^#\s]*)?$/;

/** The quote path a grant sends the browser to, when it names one. Anything
 * that is not a same-origin quote path is ignored. */
export function grantRedirectOf(raw: unknown): string | null {
  if (typeof raw !== "object" || raw === null) return null;
  const redirect = (raw as Record<string, unknown>).redirect;
  return typeof redirect === "string" && QUOTE_REDIRECT.test(redirect)
    ? redirect
    : null;
}
